import type React from 'react'
import styled from 'styled-components'

import { Checkbox, StyledCheckbox } from '@components/ui/Checkbox'
import { Typography } from '@components/ui/Typography'

const Label = styled.label<{ $checked: boolean }>`
  margin: 0;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  -webkit-tap-highlight-color: transparent;
  gap: 6px;

  ${StyledCheckbox} {
    pointer-events: none;
    background-color: ${({ theme, $checked }) => ($checked ? 'var(--checkbox-color)' : theme.colors.gray[0])};
    border-color: var(--checkbox-color);
    color: ${({ theme }) => theme.colors.gray[0]};
  }
`

interface ChartLegendProps<ColorMap extends Record<string, string>> {
  checked: boolean
  children: NonNullable<React.ReactNode>
  colorMap: ColorMap
  dataKey: keyof ColorMap
  onToggle: VoidFunction
}

export function ChartLegend<ColorMap extends Record<string, string>>({
  checked,
  children,
  colorMap,
  dataKey,
  onToggle,
}: ChartLegendProps<ColorMap>) {
  return (
    <Label
      onClick={onToggle}
      $checked={checked}
      style={{
        '--checkbox-color': colorMap[dataKey],
      }}
    >
      <Checkbox checked={checked} />
      <Typography color="gray-80" size="400-sm" tag="span">
        {children}
      </Typography>
    </Label>
  )
}
